import http from '../../../../libs/http'
export default (options = {}) => http.get(`${process.env.VUE_APP_MICROSERVICE_API_SHOPS}/order-state`, {
  params: { ...options }
})
